const iconSize = {
  width: '32px',
  height: '32px',
};

export default iconSize;
